<script lang="ts" setup></script>
<template>
  <dl class="description-list">
    <slot />
  </dl>
</template>
<style lang="scss" scoped>
dl {
  display: grid;
}
.description-list {
  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: 0;
  }

  margin-left: var(--card-padding);
  margin-right: var(--card-padding);
}
</style>
